//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';
import {
  PlatformScale,
  platformScaleStats,
} from '@/containers-ai/PlatformScale';

//styles
import {
  HeroSection,
  HeroInner,
  HeroCopy,
  Eyebrow,
  HeroTitle,
  HeroSub,
  HeroNote,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroCopy>
          <Eyebrow>
            LOADSMART AI &middot; THE INTELLIGENCE POWERING AUTONOMOUS
            TRANSPORTATION EXECUTION
          </Eyebrow>
          <HeroTitle>
            Loadsmart AI runs your freight. <br />
            <Grad>Our Freight Experts resolve the exceptions.</Grad>
          </HeroTitle>
          <HeroSub>
            Loadsmart AI works with your system of record, nothing to replace or
            migrate, and when something needs a human, our Freight Experts step
            in.
          </HeroSub>
          <HeroNote>You own the results, not the work.</HeroNote>
          <PillLink href="/contact/#contact-form">
            Watch it run your freight &#8594;
          </PillLink>
        </HeroCopy>

        <PlatformScale stats={platformScaleStats} />
      </HeroInner>
    </HeroSection>
  );
}
